import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link, NavLink, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { API_BASE, FRONT_BASE } from "../../constants/global";
import { SwalBox, Toaster } from "../../entity/GlobalJS";
import RateStart from "../../components/RateStart";
import ReportCircle from "./ReportCircle";
import authContext from "../../context/auth/authContext";

const ManageCircle = () => {
    const cntxAuth = useContext(authContext);
    const navigate = useNavigate();
    const location = useLocation();
    const is_meeting_create = window.location.href.indexOf("create-meeting") > -1 ? true : false;
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const [api_errors, setApiErrors] = useState([]);
    const [form_success, setFormSuccess] = useState('');

    const _token = localStorage.getItem('lmstoken');
    const { unique_id } = useParams();
    localStorage.setItem('learningCircleUniqueId', unique_id);

    const [group, setGroup] = useState('');

    const [requests_total, setRequestsTotal] = useState(0);
    const [members_total, setMembersTotal] = useState(0);
    const [page, setPage] = useState(1);

    const [active, setActive] = useState(true);
    const [isowner, setIsOwner] = useState(false);
    const [isadmin, setIsAdmin] = useState(false);
    const [ispublic, setIsPublic] = useState(false);
    const [owners, setOwners] = useState(false);

    const [existingShow, setExistingShow] = useState(false);
    const [viaEmailShow, setViaEmailShow] = useState(false);
    const [viaLinkShow, setViaLinkShow] = useState(false);

    const [questions, setQuestions] = useState('');
    const [feedback_id, setFeedbackId] = useState('');
    const [report_types, setReportTypes] = useState('');
    const [my_rating, setMyRating] = useState(0);

    const [rating, setRating] = useState('');
    const [feedbacks, setFeedbacks] = useState('');

    const rateArrays = [1, 2, 3, 4, 5];

    useLayoutEffect(() => {
        const onWidth1 = (window.innerWidth < 990) ? 580 : 500;
        const onWidth2 = (window.innerWidth < 990) ? 425 : 300;
        const scrollTo = (location.pathname.indexOf('feeds') === -1) ? onWidth1 : onWidth2; // for resposive 720
        window.scrollTo(0, scrollTo);
    }, [location.pathname]);

    useEffect(() => {
        setPage(1 + 1);
        fetchGroup();
        fetchQuestions();
        fetchReportTypes();
        fetchRating();
        fetchFeedbacks();
        // eslint-disable-next-line 
    }, []);

    const fetchGroup = async () => {
        const response = await fetch(`${API_BASE}get-group/${unique_id}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            if (data.message === "No data found.") {
                navigate('/404');
            }

            setOwners(data.data.group?.owners !== null ? data.data.group?.owners[0] : '');
            setGroup(data.data.group);
            setMyRating(data.data.group?.rate);
            setActive(data.data.group?.active);
            setIsOwner(data.data.isowner);
            setIsAdmin(data.data.isadmin);
            setMembersTotal(data?.data?.group?.totalMembersCount);
            setIsPublic(data.data.group?.private === 'Public' ? true : false);

            if (data.data.isowner || data.data.isadmin) {
                fetchJoinRequest();
            }
        }
    }

    const fetchQuestions = async () => {
        const response = await fetch(API_BASE + 'get-feedback-questions', {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            setQuestions(data.data.questions);
        }
    }

    const fetchReportTypes = async () => {
        const response = await fetch(`${API_BASE}get-report-types`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            setReportTypes(data.data.types);
        }
    }

    const fetchRating = async () => {
        const response = await fetch(`${API_BASE}get-average-ratings/${unique_id}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            if (data.data.average_ratings !== null) {
                setRating(data.data.average_ratings[0]);
            }
        }
    }

    const fetchFeedbacks = async () => {
        const response = await fetch(`${API_BASE}get-average-feedback/${unique_id}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            setFeedbacks(data.data.average_feedback);
        }
    }

    const fetchJoinRequest = async () => {
        const response = await fetch(`${API_BASE}get-group-join-request/${unique_id}?page=${page}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            setRequestsTotal(data.data.count);
        } else {
            setRequestsTotal(0);
        }
    }

    const changeStaus = async (flag) => {
        const response = await fetch(`${API_BASE}change-active-status/${unique_id}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            cntxAuth.updateMessage({ message: data.message, type: 'success' });
            setActive(flag);
        }
    }

    const toggleMenu = () => {
        document.getElementById('navbarDropdown11').nextSibling.classList.toggle("show");
    }

    const toggleMenu2 = () => {
        document.getElementById('navbarDropdown12').nextSibling.classList.toggle("dshow");
    }

    const leaveCircle = async () => {
        const response = await fetch(`${API_BASE}leave-learning-circle/${unique_id}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            cntxAuth.updateMessage({ message: data.message, type: 'success' });
            navigate('/dashboard/my-circles');
        }
    }

    const closeCircle = async () => {
        const response = await fetch(`${API_BASE}close-learning-circle/${unique_id}`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            cntxAuth.updateMessage({ message: data.message, type: 'success' });
            navigate('/dashboard/my-circles');
        }
    }

    const postRate = async (rate) => {
        const formData = new FormData();
        formData.append('group_id', unique_id);
        formData.append('star_count', rate);

        const response = await fetch(`${API_BASE}post-circle-rating`, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${_token}`
            },
            body: formData
        });

        const rdata = await response.json();
        if (rdata.status) {
            setFeedbackId(rdata.data.rating.id);
            cntxAuth.updateMessage({ message: rdata.message, type: 'success' });
            document.getElementById('closeratingModalLongTitle').click();
            document.getElementById('nextModalCenterclick').click();
            setMyRating(rate);
        } else {
            cntxAuth.updateMessage({ message: rdata.message, type: 'error' });
        }
    }

    const ConfirmDelete = (leave = true) => {
        SwalBox.fire({
            title: 'Are you sure?',
            text: `Sure to ${leave ? 'leave' : 'close'} circle?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                if (leave) {
                    leaveCircle();
                } else {
                    closeCircle();
                }
            }
        });
    }

    const onSaveFeedback = async (form) => {
        const response = await fetch(`${API_BASE}post-circle-feedback/${feedback_id}`, {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
            body: JSON.stringify(form)
        });

        const rdata = await response.json();
        if (rdata.status) {
            document.getElementById('nextModalCenterClose').click();
            cntxAuth.updateMessage({ message: rdata.message, type: 'success' });
        } else {
            cntxAuth.updateMessage({ message: rdata.message, type: 'error' });
        }
    }

    return (
        <>
            {
                (group !== '')
                &&
                <>
                    <section className="top_banner_section white_bg">
                        <div className="container">
                            <div className="circle-cover-img">
                                <img src={group.image} className="circle-cover w-100" alt="" />
                                <div className="created-by"><b>Created by:</b> {group.owner}</div>
                            </div>
                            <div className="row circle-title-btn">
                                <div className="col-md-6 col-lg-6 circle-title">
                                    <h2>{group.title}</h2>
                                    <p>
                                        {
                                            rating !== ''
                                            &&
                                            <>
                                                <a className="ratingview cursor-pointer" data-toggle="modal" data-target="#ratingviewModalCenter"><i className="far fa-star"></i> {rating.average} Rating</a>
                                                &nbsp;
                                            </>
                                        }
                                        {group.private} Circle - {members_total} members
                                    </p>
                                    <div className="modal fade ratingviewpop" id="ratingviewModalCenter" tabIndex="-1" role="dialog" aria-labelledby="ratingviewModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h4 className="modal-title" id="ratingviewModalLongTitle">Current Rating</h4>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="rating_pop_mai">
                                                        <h4>{rating.average} Rating</h4>
                                                        {
                                                            feedbacks !== '' && feedbacks.feedback !== null
                                                            &&
                                                            <div className="feedback_detailed-view">
                                                                <ul className="list-feedbacks">
                                                                    {
                                                                        feedbacks.feedback.map((feedback, indexx) => {
                                                                            return (
                                                                                <li key={indexx}>
                                                                                    <span>{feedback.question}</span>
                                                                                    <div className="feedback-percent">
                                                                                        <span style={{ width: feedback.feedback.Yes + '%' }} className="yes">{feedback.feedback.Yes}%</span>
                                                                                        <span style={{ width: feedback.feedback.No + '%' }} className="no">{feedback.feedback.No}%</span>
                                                                                        <span style={{ width: feedback.feedback.Not_Sure + '%' }} className="not_sure">{feedback.feedback.Not_Sure}%</span>
                                                                                    </div>
                                                                                </li>
                                                                            )
                                                                        }
                                                                        )
                                                                    }
                                                                </ul>
                                                                <ul className="percent-courns">
                                                                    <li className="one">0</li>
                                                                    <li className="two">20</li>
                                                                    <li className="three">40</li>
                                                                    <li className="four">60</li>
                                                                    <li className="five">80</li>
                                                                    <li className="six">100</li>
                                                                </ul>
                                                                <div className="template_names">
                                                                    <span className="yes">Yes</span>
                                                                    <span className="no">No</span>
                                                                    <span className="not_sure">Not Sure</span>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-6 circle-dropdown text-right">
                                    <a onClick={() => { navigate(`/dashboard/my-circles/i-have-created`); }} className="btn btn-circle btn-info mr-3">Back to Dashboard</a>

                                    {
                                        (isowner && active === true)
                                        &&
                                        <span onClick={(e) => { changeStaus(false); }} className="btn btn-circle btn-success mr-3">Deactivate</span>
                                    }

                                    {
                                        (isowner && active !== true)
                                        &&
                                        <span onClick={(e) => { changeStaus(true); }} className="btn btn-circle btn-info mr-3">Activate</span>
                                    }

                                    {
                                        ((isowner || isadmin || ispublic) && active === true)
                                        &&
                                        <>
                                            <div className="dropdown inline-block">
                                                <span onClick={(e) => { toggleMenu2(); }} className="btn btn-circle btn-info mr-3" id="navbarDropdown12"><i className="fa fa-plus" aria-hidden="true"></i> Invite</span>
                                                <div className="dropdown-menu sm-menu border-top invitedrop">
                                                    <ul>
                                                        <li><span onClick={() => { setExistingShow(true); toggleMenu2(); }} className="dropdown-item"><strong><i className="fas fa-user"></i> Invite EduKula Users</strong></span></li>
                                                        <li><span onClick={() => { setViaEmailShow(true); toggleMenu2(); }} className="dropdown-item"><strong><i className="fas fa-envelope"></i> Invite via email</strong></span></li>
                                                        <li><span onClick={() => { setViaLinkShow(true); toggleMenu2(); }} className="dropdown-item"><strong><i className="fas fa-link"></i> Invite with link</strong></span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    <div className="profile-detail">
                                        <ul>
                                            <li className="nav-item dmenu dropdown">
                                                <span onClick={(e) => { toggleMenu(); }} className="nav-link dropdown-toggle" id="navbarDropdown11"><img src={owners.profile} className="rounded-circle" alt="Profile" /></span>
                                                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                                    <Link to={`/profile-details/${owners.user_slug}`} className="dropdown-item">View Profile</Link>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {
                                    active
                                        ?
                                        <div className="col-md-12">
                                            <div className="invite_nav_bnr">
                                                <div className="circle-navlinks">
                                                    <NavLink className={`nav-link`} to={`/view-learning-circle/${unique_id}/feeds`}><span>Group Feed</span></NavLink>
                                                    <NavLink className={`nav-link ${is_meeting_create ? 'active' : ''}`} to={`/view-learning-circle/${unique_id}/meetings`}>Meetings</NavLink>
                                                    <NavLink className={`nav-link`} to={`/view-learning-circle/${unique_id}/materials`}>Materials</NavLink>
                                                    <NavLink className={`nav-link`} to={`/view-learning-circle/${unique_id}/members`}>Members</NavLink>
                                                    <div className="more-options-link">
                                                        <span id="MoreMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">More <i className="fas fa-angle-down"></i></span>
                                                        <div className="dropdown-menu dropdown-menu-right" aria-labelledby="MoreMenuButton">
                                                            {
                                                                group.course !== ''
                                                                &&
                                                                <Link to={`/course-details/${group.course_slug}`} className="dropdown-item ek-lrs-course-initialized" data-ek-lrs-url={`/course-details/${group.course.slug}`} data-ek-lrs-title={group.course.title}>View Parent Course</Link>
                                                            }

                                                            {
                                                                (group.private !== 'Public' && (isowner || isadmin))
                                                                &&
                                                                <NavLink className={'dropdown-item'} to={`/view-learning-circle/${unique_id}/join-requests`}>Manage Join Requests <span className="request-count">{requests_total}</span></NavLink>
                                                            }

                                                            {
                                                                (isowner || isadmin)
                                                                &&
                                                                <NavLink className={'dropdown-item'} to={`/view-learning-circle/${unique_id}/sent-invitations`}>Sent Invitations</NavLink>
                                                            }

                                                            {
                                                                isowner
                                                                &&
                                                                <a onClick={(e) => { ConfirmDelete(false); }} className="dropdown-item">Close Circle</a>
                                                            }
                                                            <a onClick={(e) => { ConfirmDelete(); }} className="dropdown-item">Leave Circle</a>
                                                            <a className="dropdown-item" data-toggle="modal" data-target="#reportModalCenter">Report Circle</a>
                                                        </div>
                                                    </div>
                                                </div>

                                                <ReportCircle report_types={report_types} unique_id={unique_id} for_course={false} course_id={''} />

                                                <a className="rating_text" data-toggle="modal" data-target="#ratingModalCenter"><i className="fas fa-star"></i> Rate this Circle</a>
                                                <div className="modal fade ratingpopup" id="ratingModalCenter" tabIndex="-1" role="dialog" aria-labelledby="ratingModalCenterTitle" aria-hidden="true">
                                                    <div className="modal-dialog modal-dialog-centered" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h4 className="modal-title" id="ratingModalLongTitle">How would you rate this circle?</h4>
                                                                <button type="button" id="closeratingModalLongTitle" className="close" data-dismiss="modal" aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <h5>Select Rating</h5>
                                                                {
                                                                    rateArrays.map((rate_val, indexv) =>
                                                                        <RateStart key={indexv} postRate={postRate} value={rate_val} my_rating={my_rating} />
                                                                    )
                                                                }
                                                                <div className="clear"></div>
                                                                <div className="btn_right">
                                                                    <button type="button" data-dismiss="modal">Cancel</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <a id="nextModalCenterclick" className="d-none" data-toggle="modal" data-target="#nextModalCenter"><i className="fas fa-star"></i></a>
                                                <div className="modal fade ratingpopup2" id="nextModalCenter" tabIndex="-1" role="dialog" aria-labelledby="nextModalCenterTitle" aria-hidden="true">
                                                    <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h4 className="modal-title" id="nextModalLongTitle">Please tell us more (optional).</h4>
                                                                <button type="button" id="nextModalCenterClose" className="close" data-dismiss="modal" aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <form onSubmit={handleSubmit(onSaveFeedback)}>
                                                                    {
                                                                        (questions !== '' && questions !== null)
                                                                        &&
                                                                        questions.map((question, index) =>
                                                                            <div key={index} className="form-group">
                                                                                <label>{question.question}</label>
                                                                                <div className="form-check">
                                                                                    <input {...register(`feedback.${question.id}`)} id={`exampleRadios1${index}1`} className="form-check-input" type="radio" value="Yes" />
                                                                                    <label className="form-check-label" htmlFor={`exampleRadios1${index}1`}>Yes</label>
                                                                                </div>
                                                                                <div className="form-check">
                                                                                    <input {...register(`feedback.${question.id}`)} className="form-check-input" id={`exampleRadios1${index}2`} type="radio" value="No" />
                                                                                    <label className="form-check-label" htmlFor={`exampleRadios1${index}2`}>No</label>
                                                                                </div>
                                                                                <div className="form-check disabled">
                                                                                    <input {...register(`feedback.${question.id}`)} className="form-check-input" id={`exampleRadios1${index}3`} type="radio" value="Not Sure" />
                                                                                    <label className="form-check-label" htmlFor={`exampleRadios1${index}3`}>Not Sure</label>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }

                                                                    <div className="clearfix"></div>
                                                                    <div className="btn_right">
                                                                        <input type="submit" value="Save" />
                                                                        <button type="button" data-dismiss="modal">Cancel</button>
                                                                    </div>
                                                                    <div className="clearfix"></div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="col-12">
                                            <div className="empty_state">
                                                <h3>This circle is currently inactive!</h3>
                                                <img alt="" src="images/no_courses.png" />
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    </section>

                    {
                        active
                        &&
                        <>
                            <Outlet context={[group, setRequestsTotal, isowner, isadmin, members_total, setMembersTotal]} />

                            <InviteExistingUser show={existingShow} onHide={() => setExistingShow(false)} unique_id={unique_id} />
                            <InviteViaEmail show={viaEmailShow} onHide={() => setViaEmailShow(false)} unique_id={unique_id} />
                            <InviteViaLink show={viaLinkShow} onHide={() => setViaLinkShow(false)} unique_id={unique_id} />
                        </>
                    }
                </>
            }
        </>
    );
}

const InviteExistingUser = (props) => {
    const _token = localStorage.getItem('lmstoken');
    const [users, setUsers] = useState([]);
    const { register, handleSubmit } = useForm();
    const [processing, setProcessing] = useState(false);
    const [api_errors, setApiErrors] = useState([]);
    const [form_success, setFormSuccess] = useState('');

    const fetchUsers = async (search) => {
        setProcessing(true);
        const response = await fetch(`${API_BASE}search-user/${search}/${props.unique_id}/false`, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": `Bearer ${_token}`
            },
        });

        const data = await response.json();
        if (data.status) {
            setUsers(data.data.users);
        } else {
            setUsers([]);
        }

        setProcessing(false);
    }

    const SearchUser = (e) => {
        const search = e.target.value;

        if (search.length > 0 && search !== '') {
            fetchUsers(search);
        }
    }

    const onSubmit = async (form) => {
        setProcessing(true);

        if (form.existing_users === false || form.existing_users.length <= 0) {
            setApiErrors({ 'other_error': ["Please select any user to invite."] });
            setProcessing(false);
            return false;
        }

        const formData = new FormData();
        formData.append('existing_users', form.existing_users);
        var sURL = `${API_BASE}invite-existing-member-to-learningcircle/${props.unique_id}`;
        const response = await fetch(sURL, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${_token}`
            },
            body: formData
        });

        const rdata = await response.json();
        if (rdata.status) {
            document.getElementById('search_user_control').value = '';
            setUsers([]);
            setApiErrors([]);
            setFormSuccess(rdata.message);
            setTimeout(() => {
                setFormSuccess('');
                props.onHide();
            }, 2000);
        } else {
            setApiErrors(rdata.message);
        }

        setProcessing(false);
    }

    return (
        <Modal
            className="invitePopup header_red"
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <h4>Invite EduKula User</h4>
                <button type="button" className="close" onClick={props.onHide}><span aria-hidden="true">×</span></button>
            </Modal.Header>
            <Modal.Body className="scroll_add">
                {form_success ? <div className="row"><div className="col-12 mb-3 mt-0"><span className="text-success">{form_success}</span></div></div> : null}
                {api_errors?.other_error ? <div className="row"><div className="col-12 mb-2 mt-0"><span className="text-danger">{api_errors?.other_error}</span></div></div> : null}
                <div id="invite_user" className="invitepop">
                    <div className="form-group">
                        <i className="fas fa-search"></i><input onChange={(e) => { SearchUser(e); }} type="text" className="form-control" id="search_user_control" placeholder="Search for user by name" />
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="member_list invitemax_scroll">
                            <ul>
                                {
                                    (typeof users !== 'undefined' && users.length > 0)
                                    &&
                                    <>
                                        {
                                            users.map((user, index) =>
                                                <li key={index}>
                                                    <div className="list_img">
                                                        <div className="img_box">
                                                            <img src={user.image} alt="" />
                                                        </div>
                                                        <h5>{user.name}
                                                            {
                                                                user?.headline
                                                                &&
                                                                <span>{user?.headline}</span>
                                                            }
                                                        </h5>
                                                        <input {...register("existing_users[]")} type="checkbox" value={user.id} />
                                                    </div>
                                                </li>
                                            )
                                        }
                                    </>
                                }
                                {
                                    (typeof users === 'undefined' || users.length <= 0)
                                    &&
                                    <>
                                        <li>
                                            <div className="list_img text-center">
                                                <h5>No user found.</h5>
                                            </div>
                                        </li>
                                    </>
                                }
                            </ul>
                            <div className="clearfix"></div>
                        </div>
                        <div className="btn_right pad0">
                            <button onClick={props.onHide} type="button" className="btn btn-circle btn-md cancel-btn">Cancel</button>
                            {
                                typeof users !== 'undefined' && users.length > 0
                                &&
                                <button className="btn btn-circle btn-md submit-pink-btn">
                                    {
                                        processing
                                        &&
                                        <i className="fa fa-refresh fa-spin fa-fw"></i>
                                    }
                                    {
                                        !processing
                                        &&
                                        "Send Invitations"
                                    }
                                </button>
                            }
                        </div>
                    </form>
                    <div className="clearfix"></div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

const InviteViaEmail = (props) => {
    const _token = localStorage.getItem('lmstoken');
    const { register, handleSubmit, formState: { errors }, setValue, setError, setFocus } = useForm();
    const [emails, setEmails] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [api_errors, setApiErrors] = useState([]);
    const [form_success, setFormSuccess] = useState('');

    const onSubmit = async (data) => {
        if (emails.length >= 30) {
            setError("email", { type: "focus", message: 'Maximum 30 invitation can be sent at a time.' }, { shouldFocus: false });
            return false;
        }

        setProcessing(true);
        var iEmail = data.email;

        if (emails.indexOf(iEmail) !== -1) {
            setError("email", { type: "focus", message: 'This email already in the list.' }, { shouldFocus: true });
            setProcessing(false);
            return false;
        }

        const formData = new FormData();
        formData.append('email', iEmail);
        var sURL = `${API_BASE}check-email-exists/${props.unique_id}`;
        const response = await fetch(sURL, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${_token}`
            },
            body: formData
        });

        const rdata = await response.json();
        if (rdata.status && rdata.data.exists === true) {
            setError("email", { type: "focus", message: 'The email is already exists in the circle.' }, { shouldFocus: true });
            setProcessing(false);
            return false;
        }

        setEmails([...emails, data.email]);
        setValue('email', '');
        setFocus('email');
        setProcessing(false);
    }

    const sendInvitation = async () => {
        const message = document.getElementById('invite_message_box').value;
        var formData = new FormData();
        for (var i = 0; i < emails.length; i++) {
            formData.append('members[]', emails[i]);
        }
        formData.append('message', message);

        var sURL = `${API_BASE}invite-to-group/${props.unique_id}`;
        const response = await fetch(sURL, {
            method: 'POST',
            headers: {
                "Authorization": `Bearer ${_token}`
            },
            body: formData
        });

        const rdata = await response.json();
        if (rdata.status) {
            setEmails([]);
            setValue('email', '');
            setApiErrors([]);
            setFormSuccess(rdata.message);
            setTimeout(() => {
                setFormSuccess('');
                props.onHide();
            }, 2000);
        } else {
            setApiErrors(rdata.message);
        }

    }

    const removeItem = async (e, item) => {
        const newEmails = [];

        emails.forEach((email, index) => {
            if (item !== email) {
                newEmails.push(email);
            }
        });

        setEmails(newEmails);
    }

    return (
        <Modal
            className="invitePopup header_red"
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <h4>Invite via email</h4>
                <button type="button" className="close" onClick={props.onHide}><span aria-hidden="true">×</span></button>
            </Modal.Header>
            <Modal.Body>
                {form_success ? <div className="row"><div className="col-12 mb-3 mt-0"><span className="text-success">{form_success}</span></div></div> : null}
                {api_errors?.other_error ? <div className="row"><div className="col-12 mb-2 mt-0"><span className="text-danger">{api_errors?.other_error}</span></div></div> : null}
                <div id="invite_email" className="invitepop">
                    <p className="text-label-invite"><strong>Invitation message email recipients will see</strong></p>
                    <textarea rows="3" className="form-control" id="invite_message_box" placeholder="This message will be sent to the invited users." defaultValue="Hello, I am thrilled to invite you to join my learning circle on EduKula. Let's connect on the circle and learn together!"></textarea>
                    {
                        api_errors?.message
                            ?
                            <span className="text-danger">
                                {api_errors?.message.join(' ')}
                            </span>
                            :
                            null
                    }
                    <br />
                    <>
                        <strong>Add email addresses to invite</strong>
                        <p>You can send invitations to up to 30 people at once by adding more email addresses. For adding multiple emails at once, use comma-separated emails.</p>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="email_box">
                                <input {...register("email", {
                                    required: "required",
                                    pattern: {
                                        value: /\S+@\S+\.\S+/,
                                        message: "Entered value does not match email format"
                                    }
                                })} type="text" placeholder="Enter email address" />
                                <button className="btn btn-circle btn-info ml-2">
                                    {
                                        processing
                                        &&
                                        <i className="fa fa-refresh fa-spin fa-fw"></i>
                                    }
                                    {
                                        !processing
                                        &&
                                        "Add"
                                    }
                                </button>
                            </div>
                            <span className="text-danger">
                                {errors.email && errors.email.type === "required" && 'Please enter email address'}
                                {errors.email && errors.email.type !== "required" && errors.email.message}
                            </span>
                            {
                                api_errors?.email
                                    ?
                                    <span className="text-danger">
                                        {api_errors?.email.join(' ')}
                                    </span>
                                    :
                                    null
                            }
                        </form>
                    </>

                    {
                        emails.length > 0
                        &&
                        <>
                            <hr />
                            <ul className="list-add-email-invite">
                                {
                                    emails.map((email, index) =>
                                        <li key={index}>
                                            <span>{email}</span>
                                            <i onClick={(e) => { removeItem(e, email) }} className="fa fa-times text-danger float-right mt-1" title="Close" aria-hidden="true"></i>
                                        </li>
                                    )
                                }
                            </ul>
                        </>
                    }

                    <div className="btn_right">
                        {
                            emails.length > 0
                            &&
                            <input className="btn btn-circle btn-md submit-pink-btn" onClick={(e) => { sendInvitation() }} disabled={processing} type="submit" value="Send" />
                        }
                        <button onClick={props.onHide} type="button" className="btn btn-circle btn-md cancel-btn">Cancel</button>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

const InviteViaLink = (props) => {
    const [form_success, setFormSuccess] = useState('Copy Link');

    const copyToClipboard = () => {
        navigator.clipboard.writeText(`${FRONT_BASE}learning-circle-details/${props.unique_id}`);
        setFormSuccess('Link Copied!');
        setTimeout(() => {
            setFormSuccess('Copy Link');
        }, 5000);
    }

    return (
        <Modal
            className="invitePopup header_red"
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <h4>Invite with link</h4>
                <button type="button" className="close" onClick={props.onHide}><span aria-hidden="true">×</span></button>
                {/* <i onClick={props.onHide} className="fa fa-times text-danger" title="Close" aria-hidden="true"></i> */}
            </Modal.Header>
            <Modal.Body>
                <div id="invite_link" className="invitepop">
                    <strong>{`${FRONT_BASE}learning-circle-details/${props.unique_id}`}</strong>
                    <div className="btn_left float-right">
                        <button className="btn btn-circle btn-md submit-pink-btn" onClick={() => { copyToClipboard(); }} type="button">{form_success}</button>
                    </div>
                    <div className="clearfix"></div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ManageCircle;